import Translation from '../../../../translation/translation';

function FitterType(props) {
    var classNames = ['fsf-station__fitter-type'];
    if (props.isMobileFitter) {
        classNames.push('fsf-station__fitter-type--mobile-fitter');
    } else {
        classNames.push('fsf-station__fitter-type--stationary-fitter');
    }

    const stationaryTranslation = props.vehicleCollectAndReturnService ?
        <Translation translationKey="fitting-station-finder-app-collect-fit-return-fs-list" />:
        <Translation translationKey="fitting-station-finder-app-stationary-fitter" />;


    return (
        <span className={classNames.join(' ')}>
            {
                props.isMobileFitter &&
                <Translation translationKey="fitting-station-finder-app-mobile-fitter" />
            }
            {
                !props.isMobileFitter &&
                stationaryTranslation
            }
        </span>
    );
}

export default FitterType;